const sampleAvatar =
  'https://pbs.twimg.com/profile_images/803832195970433027/aaoG6PJI_400x400.jpg';

export default sampleAvatar;
